import { API } from '@/api';
import { fetcher } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type PostalsParams, postalsResponseSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchPostals = (params: PostalsParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  const { city, country, limit = 10, offset = 0, portPostal, sorting, state } = params;

  return masterDataApi
    .get('postal', {
      searchParams: toURLSearchParams({
        'InlineSearch[cityName]': city || undefined,
        'InlineSearch[countryCode]': country,
        'InlineSearch[postalCode]': portPostal || undefined,
        'InlineSearch[stateCode]': state || undefined,
        Skip: offset,
        Sorting: sorting || 'cityName asc',
        Take: limit,
      }),
      signal,
    })
    .json(postalsResponseSchema);
};
